import Vue from 'vue'
import config from '@/config/index'

export default {
  namespaced: true,
  state: {
    sectionItem: {},
    sectionItems: [],
    sectionDepartmentItems: [],
    subSectionItems: []
  },
  getters: {
    sectionItem (state) {
      console.log('getters > sectionItem called...')
      return state.sectionItem
    },
    sectionItems (state) {
      return state.sectionItems
    },
    sectionDepartmentItems (state) {
      return state.sectionDepartmentItems
    },
    subSectionItems (state) {
      return state.subSectionItems
    }
  },
  mutations: {
    setSection (state, payload) {
      state.sectionItem = payload
    },
    setSectionItems (state, payload) {
      state.sectionItems = payload
    },
    setSectionDepartmentItems (state, payload) {
      state.sectionDepartmentItems = payload
    },
    setSubSectionItems (state, payload) {
      state.subSectionItems = payload
    },
    resetSectionData (state) {
      state.sectionItemData = {}
    }
  },
  actions: {
    createSection ({ commit, dispatch }, payload) {
      console.log('actions createSection', payload)
      return new Promise((resolve, reject) => {
        Vue.axios.post(`${config.serverURI}/sections`, payload).then((response) => {
          console.log('on create section', response)
          dispatch('fetchSectionsByActiveCourse', payload.activeCourse)
          dispatch('snackbarOnSaveSuccess')
          resolve(response)
        }).catch((error) => {
          console.log('createAcademicYear', error.response)
          reject(error)
          dispatch('snackbarOnLoadFail', error.response.data.message)
        })
      })
    },
    fetchSectionsByActiveCourse ({ commit, dispatch }, payload) {
      console.log('actions fetchSectionsByActiveCourse')
      Vue.axios.get(`${config.serverURI}/sections/findAllByActiveCourse/${payload}`).then((response) => {
        console.log('sections', response.data)
        commit('setSectionItems', response.data)
      }).catch((error) => {
        console.log(error)
        dispatch('snackbarOnLoadFail', error.response.data.message)
      })
    },
    resetSectionData ({commit}) {
      commit('resetSectionData')
    },
    setSection ({ commit }, payload) {
      console.log('actions setSection', payload)
      commit('setSection', payload)
    },
    
    loadItems ({ commit, dispatch }, payload) {
      console.log('-> loadItems')
      return Vue.axios.get(`${config.serverURI}/sections`)
    },
    loadItemsAsPage ({ commit, dispatch }, pagination) {
      console.log('-> loadItemsAsPage', pagination)
      return Vue.axios.get(`${config.serverURI}/sections/page/${pagination.activeCourseId}`, { params: pagination })
    },
    fetchItem ({ commit, dispatch }, payload) {
      console.log('-> fetchItem', payload)
      return Vue.axios.get(`${config.serverURI}/sections/${payload}`)
    },
    fetchItemByActiveCourse ({ commit, dispatch }, payload) {
      console.log('-> fetchItemByActiveCourse', payload)
      return Vue.axios.get(`${config.serverURI}/sections/findAllByActiveCourse/${payload}`)
    },
    create ({ commit, dispatch }, payload) {
      console.log('-> create', payload)
      return Vue.axios.post(`${config.serverURI}/sections`, payload)
    },
    update ({ commit, dispatch }, payload) {
      console.log('-> update', payload)
      return Vue.axios.put(`${config.serverURI}/sections/${payload.id}`, payload)
    },
    delete ({ commit, dispatch }, payload) {
      console.log('-> delete', payload)
      return Vue.axios.delete(`${config.serverURI}/sections/${payload.id}`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/section.js